import {
  InternalAdTrackingData,
  InternalAdTrackingDataParams,
} from "@shared/services/event_tracking/entities/ads/internal_ad_tracking_data";

interface BrowseByAdEntityParams extends InternalAdTrackingDataParams {
  placement_content_key: string;
  image_url: string;
  product_line_ids: number[];
}

export class BrowseByAdEntity extends InternalAdTrackingData {
  // The placement_content_key corresponds to the ad placement content_position_key. However, we have left this field name as is,
  // rather than changing to placement_content_position_key, so as to not impact reporting.
  placement_content_key: string;
  placement_image_url: string;
  product_line_ids: number[];

  constructor(params: BrowseByAdEntityParams) {
    super(params);
    this.type = "popular_categories_content_card_ad";
    this.entity_version = 2;
    this.placement_content_key = params.placement_content_key;
    this.placement_image_url = params.image_url;
    this.product_line_ids = params.product_line_ids;
  }
}
